
import React, { useState } from 'react';
import { Camera, Book, Heart, Play, Pause, Video, Mic, Upload, Users, Home, Settings, Star, Cloud, Moon, Sun, ChevronRight, Plus, Check, X, Mail, Lock, User, ArrowRight } from 'lucide-react';

export const Button = ({ children, onClick, variant = 'primary', style = {}, ...props }) => {
  const baseStyle = {
    padding: '0.75rem 1.5rem',
    border: 'none',
    borderRadius: '0.75rem',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '1rem',
    transition: 'all 0.3s',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    ...style
  };

  const variants = {
    primary: {
      background: 'linear-gradient(90deg, #9333ea 0%, #7e22ce 100%)',
      color: 'white',
      boxShadow: '0 10px 15px rgba(0,0,0,0.1)',
    },
    secondary: {
      background: 'linear-gradient(90deg, #db2777 0%, #be185d 100%)',
      color: 'white',
      boxShadow: '0 10px 15px rgba(0,0,0,0.1)',
    },
    secondary1: {
      background: 'linear-gradient(90deg, #f7f7f7ff 0%, #c2c2c2ff 100%)',
      color: 'black',
      boxShadow: '0 10px 15px rgba(0,0,0,0.1)',
    },
    secondary2: {
      background: 'linear-gradient(90deg, #72b5efff 0%, #256affff 100%)',
      color: 'black',
      boxShadow: '0 10px 15px rgba(0,0,0,0.1)',
    },
    reader: {
      background: 'linear-gradient(90deg, #87db27ff 0%, #18be41ff 100%)',
      color: 'white',
      boxShadow: '0 10px 15px rgba(0,0,0,0.1)',
    },
    outline: {
      background: 'transparent',
      color: '#9333ea',
      border: '2px solid #9333ea',
    },
    ghost: {
      background: 'white',
      color: '#374151',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    },
    blue: {
      background: 'linear-gradient(90deg, #335eeaff 0%, #2d22ceff 100%)',
      color: 'white',
      boxShadow: '0 10px 15px rgba(0,0,0,0.1)',
    }
  };

  return (
    <button 
      onClick={onClick} 
      style={{ ...baseStyle, ...variants[variant] }}
      {...props}
    >
      {children}
    </button>
  );
};